import { isEmpty, isUndefined } from 'lodash';

const getChildrenValue = (object, parent, children) => {
  if (!isEmpty(object)) {
    if (!isEmpty(object[parent]) || !isUndefined(object[parent])) {
      return children ? object[parent][children] : object[parent];
    }
  }
  return null;
};

export const getValidTextValue = (object, parentProp, childrenProp) => {
  const value = getChildrenValue(object, parentProp, childrenProp);
  return value === null || value === undefined ? '' : value;
};
